var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03711 3.61654L4.34128 0.258203C4.55794 0.0415365 4.88294 0.0415365 5.09961 0.258203C5.31628 0.47487 5.31628 0.79987 5.09961 1.01654L2.55378 3.61654H11.4371C14.5788 3.61654 17.1788 6.16237 17.1788 9.3582V11.3082C17.1788 11.6332 16.9621 11.8499 16.6371 11.8499C16.3121 11.8499 16.0954 11.6332 16.0954 11.3082V9.3582C16.0954 6.81237 14.0371 4.69987 11.4371 4.69987H2.55378L5.09961 7.29987C5.31628 7.51654 5.31628 7.84154 5.09961 8.0582C4.99128 8.16654 4.88294 8.2207 4.72044 8.2207C4.55794 8.2207 4.44961 8.16654 4.34128 8.0582L1.03711 4.69987C0.766276 4.42904 0.766276 3.94154 1.03711 3.61654Z",
    fill: "#183243"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.fccde7a3445267f9b88873eacfa5d7c6.svg";
export { ForwardRef as ReactComponent };